import type { LinkChangeValue, LinkProps, LinkType, Protocol } from '../iHyperlinks';

/**
 * 解析链接
 * @param value 链接对象
 * @returns 解析后的链接对象
 * @example parseLink({ linkAddress: 'http://www.baidu.com', linkText: '百度' }, hideProtocol: false);
 *        ==> { linkAddress: 'www.baidu.com', protocol: 'http:', linkText: '百度' }
 */
export const parseLink = (value?: LinkProps, hideProtocol?: boolean): LinkType | undefined => {
  if (!value) return;
  let { linkAddress } = value;
  const { linkText } = value;

  if (hideProtocol) {
    return { linkAddress, linkText };
  }

  if (!linkAddress) {
    return { linkAddress: '', protocol: 'https:', linkText };
  }

  if (linkAddress === 'http://' || linkAddress === 'https://') {
    return {
      linkAddress: '',
      protocol: linkAddress.replace('//', '') as Protocol,
      linkText,
    };
  }

  if (
    !linkAddress.trim().startsWith('http:') &&
    !linkAddress.trim().startsWith('https:')
  ) {
    linkAddress = `https://${linkAddress}`;
  }

  try {
    const url = new URL(linkAddress);

    return {
      linkAddress: linkAddress.replace(`${url.protocol}//`, ''),
      protocol: url.protocol as Protocol,
      linkText,
    };
  } catch (e: unknown) {
    if (e instanceof Error) {
      console.log(e.message);
    } else {
      console.log('invalid url');
    }
    const protocol = linkAddress.startsWith('http:') ? 'http:' : 'https:';
    return {
      linkAddress: linkAddress.replace(`${protocol}//`, ''),
      protocol,
      linkText,
    };
  }
}

export const getLinkValue = ({
  linkText,
  linkAddress,
  protocol = 'https:',
  hideProtocol,
}: LinkType & { hideProtocol?: boolean }) => {
  const linkUrl = hideProtocol ? linkAddress : `${protocol}//${linkAddress || ''}`;
  return JSON.stringify({
    linkText,
    linkAddress: linkUrl,
  }) as LinkChangeValue
};
